





















import { PropType, defineComponent, computed } from '@vue/composition-api';
import { isBefore } from 'date-fns';
import { useTranslate } from '@front-app/hooks/useTranslate';
import CertificateIcon from './CertificateIcon.vue';

export default defineComponent({
	components: {
		CertificateIcon,
	},
	props: {
		isDisabled: Boolean,
		startDate: {
			type: String as PropType<string | null>,
			default: null,
		},
	},
	setup(props, ctx) {
		const isFuture = computed(() => props.startDate && isBefore(new Date(), new Date(props.startDate)));
		const $t = useTranslate(ctx);
		const ariaLabel = computed(() => {
			if (props.isDisabled) {
				return $t('lms.user.cert-badge-aria.no-certificate');
			}
			if (isFuture.value && props.startDate) {
				return $t('lms.user.cert-badge-aria.certificate-available-date', [ctx.root.$d(new Date(props.startDate), 'short')]);
			}
			return $t('lms.user.cert-badge-aria.certificate-available-email');
		});
		return {
			isFuture,
			ariaLabel,
		};
	},
});
